export default __webpack_public_path__ + "static/media/debate_20.61653266.JPG";